// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"richTextEditor_wrapper__oo9dV","inputArea":"richTextEditor_inputArea__ZUaB5"};